import script from "./PMPStep4Comentarios.vue?vue&type=script&setup=true&lang=js"
export * from "./PMPStep4Comentarios.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__